import useLocaleLink from 'hooks/useLocaleLink';

interface ArticleListItemProps {
  title: string;
  date: string;
  href: string;
}

export default function ArticleListItem({ title, date, href }: ArticleListItemProps) {
  const localeLink = useLocaleLink();

  return (
    <a
      href={`${localeLink}${href}`}
      className="group -mx-3 flex flex-col gap-2 rounded-lg px-3 py-3 transition-colors hover:bg-base-fill-secondary pad:-mx-4 pad:gap-3 pad:px-4 pad:py-4"
    >
      <h3 className="text-base font-medium leading-6 text-base-label transition-colors group-hover:text-base-primary pad:text-lg pad:leading-[26px]">
        {title}
      </h3>
      <time className="text-sm leading-[18px] text-base-label-40 pad:text-base pad:leading-5">{date}</time>
    </a>
  );
}
